import React from "react";
import _ from "lodash";
import { useState, useEffect } from "react";
import { Container } from "react-bootstrap";
import { PageHeader } from "../features/shared";
import DRMPlanOne from "../Components/DRMPlanning/DRMPlanOne";
import Box from "@mui/material/Box";
import Tab from "@mui/material/Tab";
import dayjs from "dayjs";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";
import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
// import { getAllMeeting } from "../services/DRM/getAllMeeting";
// import { getMeetingDetails } from "../services/DRM/getMeetingDetails";
import { getTown } from "../services/DRM/getTown";
import "./DRMplanning.css";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import QRCodeGenerator from "../Components/DRMPlanning/QRCodeGenerator";
import { countFeedback } from "../services/DRM/countFeedback";
import { getAttendanceCount } from "../services/DRM/getAttendanceCount";
import { getDRMZoneApi } from "../services/DRM/getDRMZoneApi";
import { Title } from "chart.js";
import { DRMPlanOneAPI } from "../services/DRM/DRMPlanOneAPI";

const DRMplanning = () => {
  const [tabvalue, setTabValue] = useState("1");
  const [blockTab, setBlockTab] = useState(false);
  const [options, setOptions] = useState([]);
  const [meetings, setMeetings] = useState([]);
  const [nsmstatus, setNsmStatus] = useState();
  const [nsmfeedback, setNsmFeedback] = useState();
  const [meetingdetails, setMeetingDetails] = useState();
  const [executiondisable, setExecutionDisable] = useState(false);
  const [disable, setDisable] = useState(false);
  const [QRvisible, setQRvisible] = useState(false);
  const [unableupdate, setUnableUpdate] = useState(true);
  const [errors, setErrors] = useState({});
  const [mindate, setMinDate] = useState();
  const [currentmeetingid, setCurrentMeetingid] = useState();
  const [triggermeetings, setTriggerMeetings] = useState(false);
  const [loading, setLoading] = useState(false);
  const [disableactualdate, setDisableActualDate] = useState(true);
  const [townname, setTownName] = useState("");
  const [startExecution, setStartExecution] = useState(false);
  const [disableUpdate, setDisableUpdate] = useState(false);
  const [townlist, setTownList] = useState([]);
  const [disableTown, setDisableTown] = useState(false);
  const [statusCompleted, setStatusCompleted] = useState(false);
  const [feedbackcount, setFeedbackCount] = useState(0);
  const [attendancecount, setAttendanceCount] = useState(0);
  const [showReason, setShowReason] = useState(false);
  const [DisableSubmitDRM, setDisableSubmitDRM] = useState(false);
  const [failedOpen, setFailesOpen] = useState(false);
  const [snackerror, setSnackError] = useState("");
  const [zone, setZone] = useState("");
  const [excelFileName, setExcelFileName] = useState("");

  const [uploadedFile, setUploadedFile] = useState({
    fileName: "",
    base64: "",
    fileExtension: "",
    totalDealers: 0,
    totalParticipants: 0,
    dealerCode: "",
  });

  const userEmailid = useSelector(
    (state) => state?.userDetails?.details?.Email
  );
  const Sg = useSelector(
    (state) => state?.userDetails?.details?.Sales_Group_Code__c
  );
  const cluster = useSelector(
    (state) => state?.userDetails?.details?.SH_Code__c
  );
  const cluster_name = useSelector(
    (state) => state?.userDetails?.details?.SH_Name__c
  );
  //const zone = useSelector((state) => state?.userDetails?.details?.Division);
  const title = useSelector((state) => state?.userDetails?.details?.Title);

  const territoryOption = useSelector(
    (state) => state?.territory?.territoryDetails
  );

  useEffect(() => {
    try {
      const getTownFromCluster = async () => {
        const response = await getTown({ cluster });
        if (response?.success) {
          setTownList(response?.data?.records);
        }
      };
      getTownFromCluster();
    } catch (error) {
      console.error("Error fetching meetings:", error);
    }
  }, []);

  useEffect(() => {
    (async () => {
      try {
        const result = await getDRMZoneApi(userEmailid);
        if (!_.isEmpty(result?.data?.records[0])) {
          setFormData({
            ...formData,
            Zone: result?.data?.records[0].SH5_Name__c
              ? result?.data?.records[0].SH5_Name__c
              : "",
          });
          setZone(result?.data?.records[0].SH5_Name__c);
        }
      } catch (error) {
        setZone("");
        setLoading(false);
      }
    })();
  }, [userEmailid]);

  // get meetingid from url
  const useQuery = () => {
    return new URLSearchParams(useLocation().search);
  };
  const query = useQuery();
  useEffect(() => {
    const meetingid = query.get("id");
    setCurrentMeetingid(meetingid);
  }, []);

  const SpecaObj = {
    Division: "40",
    SalesGroup: "401",
    HierarchyCode: "CCMDNCA",
    VerticalName: "401",
    MeetingDate: "2023-12-29 00:00:00",
    MeetingType: "CONTRACTORS MEET Test",
    MeetingCode: "CC2349768",
    CityName: "Ahmadabad",
    TownCode: "UGJ00006",
    PerHeadCost: "500",
    InviteeCount: 85,
    AttendeeCount: 85,
    TotalAmount: "42500",
    AttendeesPhoto: "()",
    Billno: "0",
    BillPhoto: "()",
    ITrakToTEMFlag: "Y",
    ITrakToTEMDate: "2024-01-02 00:00:00",
    Attendee_KYCRecieved: 0,
    Attendee_KYCNotRecieved: 0,
    Attendee_Stakeholders: 4,
    Attendee_Helper: 0,
    Attendee_Repeat: "0",
    MeetingFormat: "Physical Meet",
    ADV_AND_PROMO: "",
    EMPLOYEECODE: "00024845",
  };

  // setCurrentMeetingid(meetingid)
  const initialFormData = {
    SG: Sg,
    Zone: zone,
    ClusterName: `${cluster} : ${cluster_name}`,
    TSITerritoryName: "",
    TownName: townname,
    DealerCity: "",
    // TownCode : "40564",
    // CustomerCode: "",
    CustomerName: "",
    Population: null,
    // TypeOfCompetitionMarket: "",
    // Quarter: "",
    ObjectiveOfMeet: null,
    TypeOfDRM: null,
    TownSelectionCriteria: null,
    DealerSelectionCriteria: null,
    IfCategorySpecificDealersThenWhichCategory: null,
    NoOfPCCdealersInTown: null,
    EstimatedNoOfDealersToParticipate: null,
    TotalHeadCountDealer: null,
    TotalHeadCountEmployee: null,
    TotalCost: null,
    CostPerHead: null,
    CurrentMonthlyAverageSalesOfTown: null,
    PostDRMMonthlyAverageSalePlannedForTheTown: null,
    TentativeDateOfTheMeet: null,
    ActualDateOfTheMeet: null,
    ActualNoOfDealersParticipated: null,
    ActualNoOfEmployeesParticipated: null,
    ActualCost: null,
    BMRemark: null,
    UserEmail: userEmailid,
    DeviationComments: "",
    // PlannedDRMType: null,
    ...(title === "TMM" && { PlannedDRMType: null }),
  };

  const [formData, setFormData] = useState(initialFormData);
  const [specaObj, setSpecaObj] = useState(SpecaObj);

  useEffect(() => {
    const fetchCurrentMeeting = async () => {
      try {
        if (!currentmeetingid) return;

        setLoading(true);

        const response = await DRMPlanOneAPI({
          method: "get",
          meetingId: currentmeetingid,
        });

        if (response?.success) {
          // STEP 1: Parse string
          const parsed = JSON.parse(response.data);

          // STEP 2: Extract record
          const record = parsed?.DRM?.[0];
          setMeetingDetails({ ...record, Id: currentmeetingid });

          // STEP 3: Handle excel file info
          if (record?.ExcelFileName) {
            setUploadedFile({
              fileName: record.ExcelFileName,
              base64: record.ExcelBase64 || "",
              fileExtension: record.ExcelFileExtension || "",
              totalDealers: 0,
              totalParticipants: 0,
              dealerCode: "",
            });

            setExcelFileName(record.ExcelFileName);
          } else {
            setUploadedFile({
              fileName: "",
              base64: "",
              fileExtension: "",
              totalDealers: 0,
              totalParticipants: 0,
              dealerCode: "",
            });

            setExcelFileName("");
          }

          const zsm = record?.ZSM_Status__c ?? record?.ZSMStatus ?? "Pending";
          const tmm = record?.TMM_Status__c ?? record?.TMMStatus ?? "Pending";
          const nsm = record?.NSM_Status__c ?? record?.NSMStatus ?? "Pending";

          // ----------- Existing logic remains the same -----------
          setShowReason(record?.CostPerHead > 1000);
          setUnableUpdate(
            !(
              (record?.NSM_Status__c ?? record.NSMStatus) === "Rejected" ||
              (record?.ZSM_Status__c ?? record?.ZSMStatus) === "Rejected" ||
              (record?.TMM_Status__c ?? record?.TMMStatus) === "Rejected"
            )
          );
          setDisableTown(
            (record?.NSM_Status__c ?? record.NSMStatus) === "Rejected" ||
              (record?.ZSM_Status__c ?? record?.ZSMStatus) === "Rejected"
          );
          setDisable(
            zsm === "Pending" || // Stage 1 pending
              (zsm === "Approved" && tmm === "Pending") || // Stage 2 pending
              (tmm === "Approved" && nsm === "Pending") // Stage 3 pending
          );
          setNsmStatus(nsm);
          setNsmFeedback(record?.NSM_Feedback__c ?? record?.NSMFeedback);

          if (record?.NSM_Status__c ?? record?.NSMStatus === "Approved") {
            setDisable(true);
            setDisableActualDate(false);
            setQRvisible(true);
            setUnableUpdate(false);
          } else if (
            record?.NSM_Status__c ??
            record?.NSMStatus === "Completed"
          ) {
            setDisable(true);
            setDisableActualDate(true);
            setQRvisible(true);
            setUnableUpdate(false);
            setDisableUpdate(false);
            setStatusCompleted(true);
            setStartExecution(true);

            const feedbackResponse = await countFeedback({ currentmeetingid });
            setFeedbackCount(feedbackResponse?.data[0]?.count || 0);

            const attendanceResponse = await getAttendanceCount({ currentmeetingid });
            setAttendanceCount(attendanceResponse?.data?.attendanceCount || 0);
          }
        } else {
          setFailesOpen(true);
          setSnackError(response?.msg);
        }
      } catch (error) {
        console.error("Error fetching meetings:", error);
        setFailesOpen(true);
        setSnackError("Error fetching meetings.");
      } finally {
        setLoading(false);
      }
    };

    fetchCurrentMeeting();
  }, [currentmeetingid]);

  // useEffect(() => {
  //   const fetchCurrentMeeting = async () => {
  //     try {
  //       if (!currentmeetingid) return;

  //       setLoading(true);
  //       const response = await getMeetingDetails({ currentmeetingid });
  //       if (response?.success) {
  //         const record = response.data.records[0];
  //         setMeetingDetails(record);

  //         // Set Excel file details if present
  //         const contentLinks = record?.ContentDocumentLinks?.records || [];
  //         console.log("Conten Links==>", contentLinks)
  //         if (contentLinks.length > 0) {
  //           const doc = contentLinks[0].ContentDocument;
  //           console.log("doc==>", doc)
  //           setUploadedFile({
  //             fileName: doc.Title,
  //             base64: "", // Not needed unless you want to display/download
  //             fileExtension: doc.FileExtension,
  //             totalDealers: 0, // Keep existing logic for new upload
  //             totalParticipants: 0,
  //             dealerCode: ""
  //           });
  //           setExcelFileName(doc.Title); // For displaying in UI
  //         } else {
  //           // If no Excel attached
  //           setUploadedFile({
  //             fileName: "",
  //             base64: "",
  //             fileExtension: "",
  //             totalDealers: 0,
  //             totalParticipants: 0,
  //             dealerCode: ""
  //           });
  //           setExcelFileName("");
  //         }

  //         // Other states based on NSM/ZSM status
  //         setShowReason(record?.Cost_Per_Head__c > 1000);
  //         setUnableUpdate(!(record?.NSM_Status__c === "Rejected" || record?.ZSM_Status__c === "Rejected"));
  //         setDisableTown(record?.NSM_Status__c === "Rejected" || record?.ZSM_Status__c === "Rejected");
  //         setDisable((record?.NSM_Status__c === "Pending" && (record?.ZSM_Status__c === "Pending" || record?.ZSM_Status__c === "Approved")));
  //         setNsmStatus(record?.NSM_Status__c);
  //         setNsmFeedback(record?.NSM_Feedback__c);

  //         if (record?.NSM_Status__c === "Approved") {
  //           setDisable(true);
  //           setDisableActualDate(false);
  //           setQRvisible(true);
  //           setUnableUpdate(false);
  //         } else if (record?.NSM_Status__c === "Completed") {
  //           setDisable(true);
  //           setDisableActualDate(true);
  //           setQRvisible(true);
  //           setUnableUpdate(false);
  //           setDisableUpdate(false);
  //           setStatusCompleted(true);
  //           setStartExecution(true);

  //           const feedbackResponse = await countFeedback({ currentmeetingid });
  //           setFeedbackCount(feedbackResponse?.data[0]?.count || 0);
  //         }

  //       } else {
  //         setFailesOpen(true);
  //         setSnackError(response?.msg);
  //       }
  //     } catch (error) {
  //       console.error("Error fetching meetings:", error);
  //       setFailesOpen(true);
  //       setSnackError("Error fetching meetings.");
  //     } finally {
  //       setLoading(false);
  //     }
  //   };

  //   fetchCurrentMeeting();
  // }, [currentmeetingid]);

  // const handleMeetingChange = async(name,newMeetingID) => {
  //     setBlockTab(false)
  //     setExecutionDisable(false)
  //     setDisable(false)
  //     setErrors({})
  //     const response = await getMeetingDetails({newMeetingID})
  //     response?.data?.records[0].NSM_Status__c == "Rejected" ? setUnableUpdate(false) : setUnableUpdate(true)
  //     if(response?.data?.records[0].NSM_Status__c == null)
  //     {
  //         setNsmStatus("Pending")
  //         setDisable(true)
  //     }
  //     else{
  //         setNsmStatus(response?.data?.records[0].NSM_Status__c)
  //     }
  //     setNsmFeedback(response?.data?.records[0].NSM_Feedback__c)
  //     if(response?.data?.records[0]?.NSM_Status__c == "Approved")
  //      {
  //         setBlockTab(true);
  //         setExecutionDisable(true)
  //         setDisable(true)
  //      }
  //     setMeetingDetails(response?.data?.records[0])
  // }
  const handleChange = (event, newValue) => {
    if (blockTab == true) {
      setTabValue(newValue);
    }
  };

  return (
    <div className="drmPlanning__OuterBox">
      <PageHeader
        title={currentmeetingid !== null ? "DRM Planning" : "Create New DRM"}
        path="/DRM-Summary"
      />
      <Container style={{ backgroundColor: "#F5F5F5" }} className="mt-0">
        {/* <Autocomplete
          disablePortal
          className="input_meeting"
          id="combo-box-demo"
          options= {options}
          getOptionLabel={(option) => option.label}
          style={{ width: '100%' }}
          onChange= {(event,newMeetingID) => handleMeetingChange("hello",newMeetingID.label)}
          renderInput={(params) => <TextField {...params} label="Select Meeting" />}
         />
         <div className="status_wrap">
         <div className="col-6">
              <h6 className="DRM_Status__lable">
                NSM status : <p style={{ color: 'green' }}>{nsmstatus}</p> 
              </h6>
         </div>
         <div className="col-6">
              <h6 className="DRM_Status__lable">
                NSM Feedback : <p style={{ color: 'green' }}>{nsmfeedback}</p> 
              </h6>
         </div>
         </div> */}
        <Box sx={{ width: "100%", typography: "body1" }}>
          <TabContext value={tabvalue}>
            <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
              <TabList
                onChange={handleChange}
                aria-label="lab API tabs example"
              >
                <Tab label="DRM" value="1" />
                {blockTab && <Tab label="QR Code" value="2" />}
              </TabList>
            </Box>
            <TabPanel value="1">
              <DRMPlanOne
                failedOpen={failedOpen}
                setFailesOpen={setFailesOpen}
                snackerror={snackerror}
                setSnackError={setSnackError}
                DisableSubmitDRM={DisableSubmitDRM}
                setDisableSubmitDRM={setDisableSubmitDRM}
                showReason={showReason}
                setShowReason={setShowReason}
                setBlockTab={setBlockTab}
                feedbackcount={feedbackcount}
                attendancecount={attendancecount}
                statusCompleted={statusCompleted}
                disableTown={disableTown}
                townlist={townlist}
                setDisableUpdate={setDisableUpdate}
                disableUpdate={disableUpdate}
                setSpecaObj={setSpecaObj}
                specaObj={specaObj}
                setTabValue={setTabValue}
                startExecution={startExecution}
                setStartExecution={setStartExecution}
                setUnableUpdate={setUnableUpdate}
                setMeetingDetails={setMeetingDetails}
                setExecutionDisable={setExecutionDisable}
                QRvisible={QRvisible}
                setTownName={setTownName}
                setDisable={setDisable}
                territoryOption={territoryOption}
                disableactualdate={disableactualdate}
                setDisableActualDate={setDisableActualDate}
                loading={loading}
                mindate={mindate}
                setErrors={setErrors}
                setTriggerMeetings={setTriggerMeetings}
                errors={errors}
                meetingdetails={meetingdetails}
                executiondisable={executiondisable}
                disable={disable}
                unableupdate={unableupdate}
                formData={formData}
                setFormData={setFormData}
                initialFormData={initialFormData}
                setLoading={setLoading}
                excelFileName={excelFileName}
                setExcelFileName={setExcelFileName}
                uploadedFile={uploadedFile}
                setUploadedFile={setUploadedFile}
              />
            </TabPanel>
            <TabPanel value="2">
              <QRCodeGenerator meetingdetails={meetingdetails} />
            </TabPanel>
          </TabContext>
        </Box>
      </Container>
    </div>
  );
};

export default DRMplanning;
